<template>
    <div component="OrderFooterAction">
        <div v-if="getOrderProject && getOrderProject.hasOrder" class="complete">
            <b>Order was created:</b>
            <p>{{ getDateWithTime(getOrderProject ? getOrderProject.order.vytvorena : null) }}</p>
        </div>
        <div v-else class="send" :class="{ confirm: removeConfirm }">
            <btn
                :icon="'shopping_cart'"
                :disabled="!isOrderAble"
                @click="removeConfirm = true"
                :text="'Order Voices'"
            ></btn>

            <div class="warning" :class="{ show: removeConfirm }">
                <div class="label">Really order?</div>
                <btn
                    for-background="dark"
                    :icon="'close'"
                    color="ghost"
                    :size="getIsSmallerScreen ? 'iconSmall' : 'icon'"
                    @click.stop="removeConfirm = false"
                />
                <btn
                    for-background="dark"
                    :icon="'check'"
                    color="ghost"
                    :size="getIsSmallerScreen ? 'iconSmall' : 'icon'"
                    @click.stop="confirmOrder"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';

export default {
    name: 'OrderFooterAction',

    data() {
        return {
            removeConfirm: false,
        };
    },

    methods: {
        ...mapActions(['storeOrder', 'loadOrderProject', 'loadProject']),
        ...mapMutations([]),

        async confirmOrder() {
            await this.storeOrder(this.getOrderProject.id);
            this.loadOrderProject(this.getOrderProject.id);
            this.loadProject(this.getOrderProject.id);
        },

        getDateWithTime(date) {
            return `${moment(date).format('YYYY.MM.DD')} at ${moment(date).format('HH:mm')}`;
        },
    },

    computed: {
        ...mapGetters(['getOrderProject', 'getIsSmallerScreen']),

        isOrderAble() {
            return this.getOrderProject && this.getOrderProject.order_character_list.length;
        },
    },

    watch: {},

    components: {},
};
</script>

<style lang="less">
@import '~@variables';

[component='OrderFooterAction'] {
    min-width: 210px;
    height: 40px;
    padding-right: 15px;
    .flex-center;

    .complete {
        .flex-center;
        flex-direction: row;

        p {
            margin: 0 0 0 5px;
        }
    }

    .send {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;

        .warning {
            .flex-row;
            justify-content: flex-end;
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            width: 100%;
            z-index: 6;
            transition: 0.3s;
            transform: translateX(-110%);
            padding: 10px 6px 10px 16px;
            background: @dark !important;
            border-radius: 30px;

            &.show {
                transform: translateX(0);
            }

            .label {
                font-weight: 700;
                color: white;
                margin-right: 10px;
                white-space: nowrap;
            }

            button {
                margin-left: 3px;
            }
        }
    }
}
</style>
